export default __webpack_public_path__ + "static/media/Authentication_2.2874dd22.svg";